import { render, staticRenderFns } from "./AssetsEquipment.vue?vue&type=template&id=35f0f615&"
import script from "./AssetsEquipment.vue?vue&type=script&lang=js&"
export * from "./AssetsEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports